module.exports = __webpack_public_path__ + "static/kakaritsuke_main-c1b0b03c5676c3dfe8fe43156f4519bf.jpg";